<template>
  <div id="app">
    <nav>
      <TopNavBar />
    </nav>
    <transition
        name="fade"
        mode="out-in"
      >
    <router-view />
    </transition>
    <Footer />
    <CookieBadge v-if="!cookie" />
    <Modal />
    
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'  
  import "bootstrap/dist/css/bootstrap.css";
  import "bootstrap-vue/dist/bootstrap-vue.css";
  import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  const ContentRepository = RepositoryFactory.get("content");

  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

  export default {
    components: {
      TopNavBar: () => import("@/components/TopNavBar.vue"),
      Modal: () => import("@/components/Modal.vue"),
      Footer: () => import("@/components/Footer.vue"),
      CookieBadge: () => import("@/components/CookieBadge.vue"),
    },
    methods:{
      async getToken(){
        const { data } = await ContentRepository.getDrupalToken()
        this.setStateData({data: data, key: 'token'})
        // console.log('token', data)
      },
      ...mapActions(['setStateData'])
    },
    computed: {
      ...mapGetters({ 
        cookie: 'getCookie'
      })
    },
    mounted(){
      this.getToken()
      // console.log('cookie 1')
      // console.log('cookie', this.cookie)
      const cookie = this.$session.get('cookie')
      
      
      if (cookie){
        // console.log('cookie', cookie)
        this.setStateData({data: cookie, key: 'cookie'})
      }

    }
  }
</script>

<style>
  body {
    background:#e1e1e1;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }
  .content {
      margin-left:5%;
      margin-right:300px;
      text-align:left;
      min-height:55vh;
    }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .w-100{
    height:100vh !important;
    width:auto !important;
    min-width:100%;
  }

  #app {
    font-family:'Avenir W01' !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-size:15px;
    line-height:180%;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: blue;
    text-decoration: none !important;

  }

  #nav a:hover {
    text-decoration: none !important;

  }

  #nav a.router-link-exact-active {
    color: blue;
  }

  /* NProgress Styles */

  #nprogress .bar {
    background: rgba(255, 255, 255, 0.8) !important;
    xheight: 100vh !important;
    height:15px;
  }

  #nprogress {
    position:fixed;
    width:100%;
    top:0;
    bottom:0;
    z-index:450;
    background:rgba(255, 255, 255, 0.8);
  }

  #nprogress .spinner-icon {

    border-top-color: #EA208F !important;
    border-left-color: #EA208F !important;
   
  }

  .page-header{
    xmargin-top:20px;
  }


  .slides .carousel-inner, .slides .carousel-item{
    height:60vh;
  }

  .slides .carousel-item img{
    min-height:60vh;
  }

  .slides .carousel-caption{
    bottom:auto;
    text-align:left;
    top:25%;
    width:40%;
    padding:25px;
    background:url('assets/white-cnr.png') no-repeat;
    background-position: top left;
  }

  li{
    margin-bottom:15px;
  }

  a, a:hover{
    color:blue;
    text-decoration: underline;
  }

  @media (max-width: 768px){
    .slides .carousel-caption{
      width:auto;
      text-align:center;
    }

    .slides .carousel-caption h1{
      font-size:1.7rem;
    }

    .content {
      margin-left:5%;
      margin-right:5%;
    }

    .home .top-nav{
        position:absolute;
    }
  }

</style>
